import { render, staticRenderFns } from "./d-card3.vue?vue&type=template&id=2b6e8271&scoped=true"
import script from "./d-card3.vue?vue&type=script&lang=js"
export * from "./d-card3.vue?vue&type=script&lang=js"
import style0 from "./d-card3.vue?vue&type=style&index=0&id=2b6e8271&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e8271",
  null
  
)

export default component.exports